import { render, staticRenderFns } from "./Center.vue?vue&type=template&id=0df90412&scoped=true"
import script from "./Center.vue?vue&type=script&scoped=true&lang=js"
export * from "./Center.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./Center.vue?vue&type=style&index=0&id=0df90412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df90412",
  null
  
)

export default component.exports